/**
 * When the login page is opened with this query param (e.g. from the iOS app's
 * system browser auth flow), a successful login will redirect to the native app
 * via jetsnode://auth/callback?accessToken=...&refreshToken=...
 *
 * When the app loads with ?in_app=1 (iOS WebView), we store that so the usual
 * "Log in" button in the web can redirect back to the app after success.
 */
export const MOBILE_AUTH_CALLBACK_PARAM = 'mobile_callback';
export const MOBILE_AUTH_CALLBACK_PARAM_VALUE = '1';

/** Query param the iOS app adds when loading the WebView so the web knows to redirect after login. */
export const IN_APP_PARAM = 'in_app';
export const IN_APP_STORAGE_KEY = 'in_app';

export const MOBILE_AUTH_CALLBACK_SCHEME = 'jetsnode';
export const MOBILE_AUTH_CALLBACK_HOST = 'auth';
export const MOBILE_AUTH_CALLBACK_PATH = 'callback';

export function buildMobileAuthCallbackUrl(accessToken: string, refreshToken: string): string {
  const params = new URLSearchParams({
    accessToken,
    refreshToken,
  });
  return `${MOBILE_AUTH_CALLBACK_SCHEME}://${MOBILE_AUTH_CALLBACK_HOST}/${MOBILE_AUTH_CALLBACK_PATH}?${params.toString()}`;
}

export function isMobileAuthCallbackRequest(searchParams: URLSearchParams): boolean {
  return searchParams.get(MOBILE_AUTH_CALLBACK_PARAM) === MOBILE_AUTH_CALLBACK_PARAM_VALUE;
}

/** True when running inside the native app WebView (set when URL had ?in_app=1). */
export function isInAppWebView(): boolean {
  if (typeof sessionStorage === 'undefined') return false;
  return sessionStorage.getItem(IN_APP_STORAGE_KEY) === '1';
}

/** Call once on app load when URL has ?in_app=1 so login can redirect back to the app. */
export function setInAppFromSearchParams(searchParams: URLSearchParams): void {
  if (searchParams.get(IN_APP_PARAM) === '1') {
    sessionStorage.setItem(IN_APP_STORAGE_KEY, '1');
  }
}
